import { render, staticRenderFns } from "./LmDashboardIcon.vue?vue&type=template&id=4463e484&"
import script from "./LmDashboardIcon.vue?vue&type=script&lang=js&"
export * from "./LmDashboardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports